import { Fragment, useEffect, useState } from "react";
import { Box, Button, Divider, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MainCard from "../../../utils/ui-components/MainCard";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import { useDispatch, useSelector } from "react-redux";
import { getState, MENU_OPEN, SET_BREADCRUMBS } from "../../../redux/actions/actions";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";
import { TabPanel } from "../../../utils/cssStyles";
import BulkSmsCampaignSettings from "./CampaignSettings";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ConfigurationService } from "../../../assets/_services/configuration-service";
import { UserService } from "../../../assets/_services/user-service";
import BulkSmsCampaignCreateAd from "./CreateAd";
import SMSCampaignReviewAndConfirm from "./ReviewAndConfirm";

export interface BulkSmsCampaignCreationValues {
  campaignName: string;
  parent_id: { value: string | number; label: string };
  mask: number | string;
  startTime: Dayjs;
  endTime: Dayjs;
  message: string;
  scheduleNow: number;
  medium: number;
  numberList: {
    numberListType: number | string; // 1- number list, 2- personalize, 3- teplate
    contactList: {
      id: number | string;
      name: string;
      cost: {
        dialog_numbers: number;
        mobitel_numbers: number;
        hutch_numbers: number;
        airtel_numbers: number;
      };
    }[];
    file: Array<File>;
  };
  channel: number | string;
}

const INITIAL_FORM_STATE: BulkSmsCampaignCreationValues = {
  channel: "",
  parent_id: { value: "", label: "" },
  campaignName: "",
  mask: "",
  startTime: dayjs().add(1, "minute"),
  endTime: dayjs().add(10, "minute"),
  message: "",
  scheduleNow: 1,
  medium: 1,
  numberList: {
    numberListType: 1,
    contactList: [],
    file: [],
  },
};

// Load the plugins
dayjs.extend(utc);
dayjs.extend(timezone);

function SMSCampaignCreation(props: { role: number }) {
  const authState = useSelector((state: any) => state.auth.authData);
  const user = getState(authState);
  const dispatch = useDispatch();
  const theme: any = useTheme();
  const [initialState, setInitialState] = useState<BulkSmsCampaignCreationValues>(INITIAL_FORM_STATE);
  const [steps] = useState(["Select Campaing Settings", "Create Ad", "Review and Conformation"]);
  const [activeStep, setActiveStep] = useState(0);
  const [blackOutTime, setBlackOutTime] = useState<{
    startTime: string;
    endTime: string;
  }>({
    startTime: "",
    endTime: "",
  });
  const [optOutTemplate, setOptOutTemplate] = useState<{
    dialog: string;
    nonDialog: string;
  }>({ dialog: "", nonDialog: "" });
  const [suffix, setSuffix] = useState("");
  const [maskList, setMaskList] = useState<{ value: number | string; label: string; type: number }[]>([]);
  const [isLoadingMask, setIsloadingMask] = useState(false);
  const [channelList, setChannelList] = useState<
    {
      value: number | string;
      label: string;
      0: { unicode: number; non_unicode: number };
      1: { unicode: number; non_unicode: number };
      dialogRate: number;
      nonDialogRate: number;
    }[]
  >([]);
  const [tax, setTax] = useState({
    value: 0,
    percentage: 0,
  });
  const [operatorValues, setOpetorValues] = useState<{
    onnet: number;
    offnet: number;
  }>({
    onnet: 0,
    offnet: 0,
  });

  useEffect(() => {
    const id = "/campaign-creation";
    dispatch({ type: MENU_OPEN, id });
    if (activeStep === 0) {
      dispatch({
        type: SET_BREADCRUMBS,
        payload: [
          { name: "Home", path: "/dashboard", bold: true, state: null },
          { name: "Campaign Creation", path: "/campaign-creation", bold: true, state: null },
          { name: "SMS Campaign", path: null, bold: false, state: null },
        ],
      });
    }
  }, []);

  useEffect(() => {
    ConfigurationService.getBlackoutTime().then((response) => {
      if (response.isSuccess) {
        const startData = response.data.data.find((item: any) => item.key === "blackout_start_timestamp");
        const endData = response.data.data.find((item: any) => item.key === "blackout_end_timestamp");

        setBlackOutTime({
          startTime: startData.value,
          endTime: endData.value,
        });
      }
    });
    ConfigurationService.getOptOutMessage().then((response) => {
      if (response.isSuccess) {
        setOptOutTemplate({
          dialog: response.data.data.find((item: any) => item.id === 5).value,
          nonDialog: response.data.data.find((item: any) => item.id === 4).value,
        });
      }
    });
    if (props.role === 2) {
      getChannelAndMaskList(user.userId);
    }
  }, []);

  useEffect(() => {
    ConfigurationService.getTaxDetails().then((response) => {
      if (response.isSuccess) {
        const data = response.data.data.map((item: any) => ({
          ...JSON.parse(item.value),
        }));

        let value = 0;
        let percentage = 0;

        data.map((item: any) => {
          if (item.isPercentage === 0) {
            value += item.rate;
          } else {
            percentage += item.rate / 100;
          }
        });

        setTax({
          percentage: percentage,
          value: value,
        });
      }
    });
  }, []);

  useEffect(() => {
    if (user.role === 1 && Number(initialState.parent_id.value) !== 0) {
    } else {
    }
  }, [initialState]);

  useEffect(() => {
    window.scroll(0, 0);
  }, [activeStep]);

  const getChannelAndMaskList = (userId: number) => {
    setIsloadingMask(true);
    const formData = {
      ownerId: userId,
      channelType: [2],
    };
    UserService.getParentChannelAndMaskList(formData).then((response) => {
      if (response.isSuccess) {
        setChannelList(
          response.data.data.getParentAssignChannelList.map((e: any) => ({
            value: e.id,
            label: e.channel_name,
            0: {
              unicode: e.unicode_character_length,
              non_unicode: e.character_length,
            },
            1: {
              unicode: e.promotional_unicode_character_length,
              non_unicode: e.promotional_character_length,
            },
            dialogRate: e.dialog_rate,
            nonDialogRate: e.non_dialog_rate,
          }))
        );
        setMaskList(
          response.data.data.getParentAssignMaskList.map((e: any) => ({
            value: e.id,
            label: e.mask_name,
            type: e.mask_type,
          }))
        );
        setIsloadingMask(false);
      } else {
        setChannelList([]);
        setMaskList([]);
        setIsloadingMask(false);
      }
    });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const isTimeDisabled = (time: Date) => {
    const blackoutStart = new Date(time);
    const [startHour, startMinute, startSecond] = blackOutTime.startTime.split(":");
    blackoutStart.setHours(Number(startHour), Number(startMinute), Number(startSecond), 0);

    const blackoutEnd = new Date(time);
    const [endHour, endMinute, endSecond] = blackOutTime.endTime.split(":");
    blackoutEnd.setHours(Number(endHour), Number(endMinute), Number(endSecond), 0);

    if (blackOutTime.startTime > blackOutTime.endTime) {
      return time < blackoutEnd || time > blackoutStart;
    } else {
      return time >= blackoutStart && time <= blackoutEnd;
    }
  };

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xs={12}>
        <Divider textAlign="center">
          <Typography sx={{ ...theme.typography.pageheader }}>
            <ScheduleSendIcon fontSize="medium" /> SMS Campaign Creation
          </Typography>
        </Divider>
      </Grid>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12} sx={{ mt: 5 }}>
        <MainCard>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => {
              const stepProps: { completed?: boolean } = {};
              const labelProps: {
                optional?: React.ReactNode;
              } = {};
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length + 1 ? (
            <Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>All steps completed - you&apos;re finished</Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button
                  onClick={() => {
                    setActiveStep(0);
                  }}
                >
                  Reset
                </Button>
              </Box>
            </Fragment>
          ) : (
            <Fragment>
              <SwipeableViews axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={activeStep}>
                <TabPanel value={activeStep} index={0} dir={theme.direction}>
                  <BulkSmsCampaignSettings
                    role={props.role}
                    initialState={initialState}
                    isLoadingMask={isLoadingMask}
                    getChannelAndMaskList={(x: any) => getChannelAndMaskList(x)}
                    setInitialState={setInitialState}
                    handleNext={handleNext}
                    optOutTemplate={optOutTemplate}
                    setSuffix={setSuffix}
                    maskList={maskList}
                    suffix={suffix}
                  />
                </TabPanel>
                <TabPanel value={activeStep} index={1} dir={theme.direction}>
                  <BulkSmsCampaignCreateAd
                    role={props.role}
                    initialState={initialState}
                    isLoadingMask={isLoadingMask}
                    getChannelAndMaskList={() => getChannelAndMaskList}
                    setInitialState={setInitialState}
                    isTimeDisabled={isTimeDisabled}
                    channelList={channelList}
                    blackOutTime={blackOutTime}
                    maskList={maskList.find((o: any) => o.value === initialState.mask)!}
                    optOutTemplate={optOutTemplate}
                    handleBack={handleBack}
                    handleNext={handleNext}
                    suffix={suffix}
                    setOpetorValues={setOpetorValues}
                  />
                </TabPanel>
                <TabPanel value={activeStep} index={2} dir={theme.direction}>
                  <SMSCampaignReviewAndConfirm
                    role={props.role}
                    initialState={initialState}
                    isLoadingMask={isLoadingMask}
                    getChannelAndMaskList={() => getChannelAndMaskList}
                    isTimeDisabled={isTimeDisabled}
                    channelList={channelList}
                    blackOutTime={blackOutTime}
                    maskList={maskList.find((o: any) => o.value === initialState.mask)!}
                    optOutTemplate={optOutTemplate}
                    handleBack={handleBack}
                    handleNext={handleNext}
                    suffix={suffix}
                    setInitialState={() => {
                      setInitialState(INITIAL_FORM_STATE);
                      setActiveStep(0);
                    }}
                    tax={tax}
                    operatorValues={operatorValues}
                  />
                </TabPanel>
              </SwipeableViews>
            </Fragment>
          )}
        </MainCard>
      </Grid>
    </Grid>
  );
}

export default SMSCampaignCreation;
